module.exports = __webpack_public_path__ + "media/images/footer/efrr-621141512654257a9e77d3a1db15980c.svg";